export default defineNuxtPlugin({
  enforce: 'pre',
  setup() {
    const clients = useRuntimeConfig().public.openFetch
    const localFetch = useRequestFetch()
    const route = useRoute()

    return {
      provide: Object.entries(clients).reduce((acc, [name, options]) => ({
        ...acc,
        [name]: createOpenFetch(localOptions => ({
          ...options,
          ...localOptions,
          onRequest(ctx) {
            const isTablet = route.path.startsWith('/tablet')

            let cookieKey = 'token'
            if (isTablet) {
              cookieKey = 'tablet_token'
            }

            const config = useRuntimeConfig().public

            options.baseURL = config.api_base_url
            const token = useCookie(cookieKey).value
            if (token === undefined || !token) return

            // Only when there is an impersonate token we use that.
            const impToken = isTablet ? null : useCookie('imp_token').value

            // @ts-expect-error TODO: ignore for now
            ctx.options.headers = new Headers(options.headers)
            ctx.options.headers.set('Authorization', `Bearer ${impToken ?? token}`)

            // @ts-expect-error TODO: ignore for now
            return localOptions?.onRequest?.(ctx)
          },
          // @ts-expect-error TODO: ignore for now
        }), localFetch),
      }), {}),
    }
  },
})
